var React = require('react');

var Form = require('react-bootstrap/lib/Form');
var FormControl = require('react-bootstrap/lib/FormControl');
var ControlLabel = require('react-bootstrap/lib/ControlLabel');
var FormGroup = require('react-bootstrap/lib/FormGroup');
var Button = require('react-bootstrap/lib/Button');

var style = {
	container: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
		width: '100%',
		position: 'absolute',
		backgroundColor: '#fff'
	},

	form: {
		width: 300
	},

	buttonLogin: {
		backgroundColor: '#03A6DC',
		borderColor: '#03A6DC',
		color: '#fff'
	}
};

var Login = React.createClass({
	
	propTypes: {
		signIn: React.PropTypes.func.isRequired
	},

	getInitialState: function() {
		return {
			email: null,
			pass: null
		}
	},

	signIn: function(email, pass) {
		this.props.signIn(email, pass);
	},

	onSubmit (e) {
	    var me = this, { email, pass } = this.state;

	    e.preventDefault();

	    me.signIn({email: email, pass: pass});
	},

	onFieldChanged (e) {
	    this.setState({[e.target.name]: e.target.value})
	},

	render: function() {
		var me = this;

		return (
			<div style={style.container}>
				<Form horizontal onChange={me.onFieldChanged} style={style.form}>
						{/*<FormGroup>
							<Button type="submit" onClick={me.onSubmit} block bsStyle="primary" disabled>
								{"Entrar com o facebook"}
							</Button>
						</FormGroup>

						<hr/>*/}

						<FormGroup  controlId="formEmail">
							<ControlLabel>{"Email"}</ControlLabel>
							<FormControl name="email" type="email" placeholder="Email"/>
						</FormGroup>

						<FormGroup  controlId="formPassword">
							<ControlLabel>{"Senha"}</ControlLabel>
							<FormControl name="pass" type="password" placeholder="Password"/>
						</FormGroup>

						<FormGroup>
							<Button type="submit" onClick={me.onSubmit} block style={style.buttonLogin}>
								{"Entrar"}
							</Button>
						</FormGroup>
					</Form>
			</div>
		);
	}

});

module.exports = Login;


// WEBPACK FOOTER //
// ./src/components/Client/Login.jsx